import React from 'react';
import '../App.css';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useConfig } from '../context/ConfigContext';
import { useAuth } from '../context/AuthContext.jsx';
import { useEffect, useState, useCallback } from "react";
import axios from 'axios';
import ReportedItemModal from '../components/reportedItemModal.js';

export const Moderation = () => {
    const { backendApiBaseUrl, isTesting } = useConfig();
    const { id, token } = useAuth();
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [selectedReport, setSelectedReport] = useState(null);
    const [showReportModal, setShowReportModal] = useState(false);

    const [filters, setFilters] = useState({
        status: 'PENDING',
        sort: 'oldest'
    });

    const fetchData = useCallback(async (pageToFetch = 1, reset = false) => {
        if (!token?.token) return;
        setLoading(true);
        
        try {
            const url = new URL(`${backendApiBaseUrl}/moderation/reports`);

            const response = await axios.post(url.toString(), {
                userId: id,
				page: pageToFetch,
                pageSize: 20,
                status: filters.status,
                sort: filters.sort,
			},
			{
				headers: {
					"Authorization": `Bearer ${token.token}`,
				}
			});

            const { data = [], pagination } = response.data;

            if (!pagination) {
                console.error('Missing pagination in response', response.data);
                setHasMore(false);
                return;
            }

            setItems(prev => reset ? data : [...prev, ...data]);

            setHasMore(pagination.hasNextPage);
            setPage(pageToFetch);

        } catch (error) {
            if (isTesting) {
                console.error('Error fetching reports:', error);
            }
        } finally {
            setLoading(false);
        }

    }, [ backendApiBaseUrl, filters, id, token, isTesting]);


    useEffect(() => {
        setItems([]);
        setPage(1);
        setHasMore(true);
        fetchData(1, true);
    }, [filters, fetchData]);


    const fetchMoreData = () => {
        if (!hasMore || loading) return;
        fetchData(page + 1);
    };

    const handleSort = (value) => {
        setFilters(prevFilters => ({ ...prevFilters, sort: value }));
    };

    const getReportedItemDetails = async (item) => {
        if (!token?.token) return;
        try {
            const url = new URL(`${backendApiBaseUrl}/moderation/reports/details`);
            
            const response = await axios.post(url.toString(), {
                reportId: item.id,
			},
			{
				headers: {
					"Authorization": `Bearer ${token.token}`,
				}
			});

            const { itemDetails, report, otherReports } = response.data.data;
            setSelectedReport({
                report,
                item: itemDetails,
                itemType: report.itemType,
                otherReports: otherReports
            });

            setShowReportModal(true);
        }
        catch (error) {
            if (isTesting) {
                console.error('Error fetching reported item details:', error);
            }
            
        }
    };

    const handleCloseModal = () => {
        setSelectedReport(null);
		setShowReportModal(false);
    };

    const onSubmitReport = async(reportData) => {
        const reportUrl = new URL(`${backendApiBaseUrl}/reports`);
        try {
            await axios.post(reportUrl.toString(), {
                reportData
            });

        } catch (error) {
            if (isTesting) {
                console.error('Error submitting report:', error);
            }
        }
    };

    const updateReport = async(updateData) => {
        if (!token?.token) return;
        const updateURL = new URL(`${backendApiBaseUrl}/moderation/reports/update`)
        try {
            await axios.post(updateURL.toString(), {
                updateData
            },
            {
                headers: {
                    "Authorization": `Bearer ${token.token}`,
                }
            });


            fetchData(1, true);
        } catch (error) {
            if (isTesting) {
                console.error('Error updating report:', error);
            }
        }
        
    }


    return (
		<div className='container-fluid m-0 p-0'>
			<div> 
				<div className='row'>
					<div className='col-12 col-md-5' id="infiniteScrollContainer" style={{flexGrow: 1, padding: 0}}> 
						<div className="d-flex justify-content-between align-items-center px-4 rounded">

							<div className='d-flex justify-content-end align-items-center'>
								<div className="p-2 ">
									<select className="form-select" value={filters.sort} style={{color:"black"}} onChange={(e) => handleSort(e.target.value)}>
										<option className='profile-filter-dropdown' value="newest">Newest</option>
										<option className='profile-filter-dropdown' value="oldest">Oldest</option>
									</select>
								</div>
							</div>
						</div>

						{items.length === 0 ? (
                            <div className="text-center mt-4" style={{  color:"#FFF" }}>
                                No items found
                            </div>
                        ) : (
                            <InfiniteScroll
                                    dataLength={items.length}
                                    next={fetchMoreData}
                                    hasMore={hasMore}
                                    loader={<h4>Loading...</h4>}
                                    scrollableTarget="infiniteScrollContainer"
                                >
                                {items.length === 0 && !loading && (
                                    <div className="text-center mt-4 text-white">
                                    No reports found
                                    </div>
                                )}
                                <div className="d-flex px-3 py-2 p fw-bold border-bottom text-muted">
                                    <div style={{ flex: 2 }}>Reporter</div>
                                    <div style={{ flex: 1 }}>Type</div>
                                    <div style={{ flex: 3 }}>Reason</div>
                                    <div style={{ flex: 1 }}>Status</div>
                                    <div style={{ flex: 1 }}>Actions</div>
                                </div>
                                {items.map(item => (
                                    <div key={item.id} className="moderation-row d-flex align-items-center px-3 py-2 border-bottom">
                                        <div style={{ flex: 2 }}>
                                            {item.reporter.username}
                                        </div>

                                        <div style={{ flex: 1 }}>
                                            {item.itemType}
                                        </div>

                                        <div style={{ flex: 3 }}>
                                            {item.reason}
                                        </div>

                                        <div style={{ flex: 1 }}>
                                            {item.status}
                                        </div>
                                        
                                        <div style={{ flex: 1 }}>
                                            <button
                                                className="btn btn-sm btn-outline-light"
                                                onClick={() => getReportedItemDetails(item)}
                                            >
                                                Review
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </InfiniteScroll>
						)}
                        {showReportModal && (
                            <ReportedItemModal
                                open={showReportModal}
                                onClose={handleCloseModal}
                                show={selectedReport !== null}
                                report={selectedReport?.report}
                                item={selectedReport?.item}
                                itemType={selectedReport?.itemType}
                                otherReports={selectedReport?.otherReports}
                                onSubmitReport={onSubmitReport}
                                id={id}
                                updateReport={updateReport}
                            />
                        )}
					</div>
				</div>
			</div>
		</div>
	);
}